<template>
    <div class="border-left-asin pl-0 pr-0">
        <div class="border-bottom justify-content-center py-3">
            <div class="productCart mx-4">
                <div class="productImg mb-2" style="text-transform: capitalize; background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
">
                    <a :href="viewLqsListingdata.product_meta.product_image" target="_blank" class="d-block"
                        style="width: 200px; margin:0 auto">
                        <img :src="viewLqsListingdata.product_meta.product_image" crossorigin="anonymous"
                            style="width: 100%;mix-blend-mode: multiply; padding: 10px;" />
                    </a>
                </div>
                <div class="mx-3 mt-3 mb-2 product-card-title" data-toggle="tooltip" data-placement="top"
                    :title="viewLqsListingdata.product_meta.product_name">
                    <a :href="viewLqsListingdata.product_meta.product_link" target="_blanck"
                        class="cursor-pointer textColor product-title d-block">
                        <p class="mb-0 pb-0">{{
                            viewLqsListingdata.product_meta.product_name }}</p> <span v-if="asinData"
                            style="font-weight:bold">({{ asinData }})</span>
                        <span v-if="asinDatafsn" style="font-weight:bold">{{ asinDatafsn }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div>
            <div class="mt-3 pb-4 border-bottom">
                <div class="">
                    <div class="">
                        <div style="text-align: center" class="graphBorder mx-4 pt-4">
                            <highcharts :options="gaugeChartData"></highcharts>
                        </div>
                        <!-- <div class="text-center graphCount">{{ viewLqsGraph }}</div> -->
                    </div>
                </div>
            </div>

            <div class="flex-column product-card">
                <div class="border-bottom pb-0 pr-0">
                    <div class="copy-breakdown"></div>
                    <div class="space-between-header  tw-px-3" v-for="(row, i) in viewLqsListingdata.copy_breakdown"
                        :key="'lqs_cb' + i" :class="plotStrip(i)">
                        <div class="textColor" style="text-transform: capitalize; padding: 6px 0px 7px 0px">
                            <!-- <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                :class="{ falseIcon: row.status == false }"></i> -->
                            <img v-if="row.status" src="Icons_SVG/checkIcon.svg" height="17" width="17"
                                class="checkIconBreakdown rounded-circle p-1" />
                            <img v-else src="Icons_SVG/crossIcon.svg" height="17" width="17"
                                class="crossIconBreakdown rounded-circle p-1" />
                        </div>
                    </div>
                </div>
                <div class="border-bottom pb-0 pr-0">
                    <div class="media-breakdown"></div>
                    <div class="space-between-header  tw-px-3" v-for="(row, i) in viewLqsListingdata.media_breakdown"
                        :key="'lqs_cb' + i" :class="plotStrip(i)">
                        <div class="textColor" style="text-transform: capitalize; padding: 6px 0px 7px 0px">
                            <!-- <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                :class="{ falseIcon: row.status == false }"></i> -->
                            <img v-if="row.status" src="Icons_SVG/checkIcon.svg" height="17" width="17"
                                class="checkIconBreakdown rounded-circle p-1" />
                            <img v-else src="Icons_SVG/crossIcon.svg" height="17" width="17"
                                class="crossIconBreakdown rounded-circle p-1" />
                        </div>
                    </div>
                </div>
                <div class="pr-0 pb-0">
                    <div class="review-breakdown"></div>
                    <div class="space-between-header  tw-px-3" v-for="(row, i) in viewLqsListingdata.review_breakdown"
                        :key="'lqs_cb' + i" :class="plotStrip(i)">
                        <div class="textColor" style="text-transform: capitalize; padding: 6px 0px 7px 0px">
                            <!-- <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                :class="{ falseIcon: row.status == false }"></i> -->
                            <img v-if="row.status" src="Icons_SVG/checkIcon.svg" height="17" width="17"
                                class="checkIconBreakdown rounded-circle p-1" />
                            <img v-else src="Icons_SVG/crossIcon.svg" height="17" width="17"
                                class="crossIconBreakdown rounded-circle p-1" />
                        </div>
                    </div>

                </div>

            </div>

        </div>
        <div class="d-flex justify-content-center align-items-center py-2">
            <router-link v-if="asinData"
                :to="'/asins-detailed/' + asinData + '/' + this.$route.params.startDate + '/' + this.$route.params.endDate">
                <button class="btn primarycolorShow">Show Details</button>
            </router-link>
            <router-link v-if="asinDatafsn"
                :to="'/fsns-detailed/' + asinDatafsn + '/' + this.$route.params.startDate + '/' + this.$route.params.endDate">
                <button class="btn primarycolorShow">Show Details</button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductCardCompare",
    props: ["asinData", "asinDatafsn", "viewLqsListingdata", "viewLqsGraph", 'index'],
    data: function () {
        return {
            gaugeChartData: {},
        };
    },

    mounted() {
        this.gaugeChart();
        this.setClass();
    },

    methods: {

        plotStrip(i) {
            let idx = i + 1;
            if (idx % 2 == 0) {

                return 'bgHighlight';
            }
            else {

                return 'bgMuted'
            }
        },

        chartHeight() {
            if (window.screen.width < 1400) {
                return 200
            }
            else
                return 175
        },
        chartSize() {
            if (window.screen.width < 1400) {
                return 200
            }
            else
                return 270
        },
        // gaugeChart() {
        //     let self = this;
        //     this.gaugeChartData = {
        //         chart: {
        //             type: "gauge",
        //             plotBackgroundImage: null,
        //             height: this.chartHeight(),
        //         },

        //         title: {
        //             text: "",
        //         },
        //         credits: {
        //             enabled: false,
        //         },
        //         pane: {
        //             center: ['50%', '90%'],
        //             size: '130%',
        //             startAngle: -90,
        //             endAngle: 90,
        //             background: {
        //                 backgroundColor: '#fff',
        //                 innerRadius: '75%',
        //                 outerRadius: '100%',
        //                 shape: 'arc',
        //                 borderColor: 'transparent'
        //             }
        //         },

        //         exporting: {
        //             enabled: false,
        //         },

        //         tooltip: {
        //             enabled: false,
        //         },

        //         yAxis: [
        //             {
        //                 min: 0,
        //                 max: 10,
        //                 minorTickPosition: "outside",
        //                 tickPosition: "outside",
        //                 labels: {
        //                     rotation: "auto",
        //                     distance: 10,
        //                 },
        //                 plotBands: [
        //                     {
        //                         from: 0,
        //                         to: 10,
        //                         color: {
        //                             stops: [
        //                                 [0, "#fd6b2d"], //yellow
        //                                 [1, "#55BF3B"], //green
        //                             ],
        //                         },
        //                         innerRadius: "90%",
        //                         outerRadius: "100%",
        //                     },
        //                     {
        //                         from: 0,
        //                         to: 4,
        //                         color: "#FF786B", // red
        //                         thickness: 20,
        //                     },
        //                     {
        //                         from: 4,
        //                         to: 8,
        //                         color: "#667BFE", // blue
        //                         thickness: 20,
        //                     },
        //                     {
        //                         from: 8,
        //                         to: 10,
        //                         color: "#42D9BC", // green
        //                         thickness: 20,
        //                     },
        //                 ],
        //                 pane: 0,
        //                 title: {
        //                     text: "",
        //                     y: 0,
        //                 },
        //             },
        //         ],

        //         plotOptions: {
        //             gauge: {
        //                 dataLabels: {
        //                     enabled: false,
        //                 },
        //                 dial: {
        //                     radius: "100%",
        //                 },
        //             },
        //         },

        //         series: [
        //             {
        //                 name: "Ratting",
        //                 data: [self.viewLqsGraph],
        //                 yAxis: 0,
        //             },
        //         ],
        //     };
        // },

        gaugeChart(totalCount) {
            let self = this;
            this.gaugeChartData = {
                chart: {
                    type: "solidgauge",
                    height: this.chartHeight(),
                    plotBackgroundImage: null,
                    backgroundColor: 'transparent',
                    spacing: [0, 0, 0, 0],
                    marginTop: -90
                },

                title: {
                    text: '',
                },
                credits: {
                    enabled: false,
                },
                pane: {
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: '#E5E5E5',
                        borderWidth: 0,
                        innerRadius: '60%',
                        outerRadius: '100%',
                        shape: 'arc'
                    },
                    center: ['50%', '85%'],
                    size: this.chartSize()
                },

                exporting: {
                    enabled: false,
                },

                tooltip: {
                    enabled: false,
                },

                yAxis: {
                    min: 0,
                    max: 10,
                    stops: [
                        [0.1, '#06555999'],
                        [0.4, '#06555999'],
                        [0.8, '#06555999'],
                    ],
                    lineWidth: 0,
                    tickWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                    labels: {
                        enabled: false,
                    },
                    plotBands: [
                        {
                            from: 0,
                            to: 10,
                            color: '#F3F3F3',
                        }
                    ],
                },

                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            enabled: true,
                            y: 10,
                            borderWidth: 0,
                            useHTML: true,
                            format: '<div style="text-align:center"><span style="font-size:40px;color:#065559;font-weight:500;">{y}</span></div>',
                        },
                    },
                },

                series: [{
                    name: 'Listing Quality Score',
                    data: [self.viewLqsGraph],
                    tooltip: {
                        valueSuffix: ''
                    },
                    color: '#065559',
                    radius: '80%',
                    innerRadius: '100%',
                    thickness: 20
                }]
            };
        },
        setClass() {
            $('.js-btn-tooltip--custom').tooltip({
                customClass: 'tooltip-custom'
            });
        }
    },
}
</script>

<style scoped>
.bgHighlight {
    /* background: #efefef; */
    background-color: #fcfcfc;
    border-bottom: 1px solid #EBEBEB;
}

.bgMuted {
    /* background: #f6f6f6; */
    background-color: #fcfcfc;
    border-bottom: 1px solid #EBEBEB;
}

.productImg {
    /* width: 160px; */
    border-bottom: 1px solid #EBEBEB;
    border-radius: 10px;
    overflow: hidden;
    margin: 0 auto;
}

.product-title {
    font-size: 14px;
}

.productImg img {
    width: 100%;
    height: 160px;
}

.textColor {
    color: #0463BA !important;
}

.border-left-asin {
    border-left: 1px solid #c8ced3 !important
}

.secondaryHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
}

.trueIcon {
    color: #64ac94 !important;
}

.falseIcon {
    color: #ff0000 !important;
}

/* .graphCount {
    font-size: 24px;
    color: "#533a79";
    font-weight: 700;
} */
div.product-card-title .product-title>span {
    color: #0463BA !important;
}

div.product-card-title .product-title>p {
    /* max-width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-clamp: 4 !important; */
    display: -webkit-box !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #0463BA !important;
}

.graphCount {
    font-size: 16px;
    color: "#533a79";
    font-weight: 700;
}


.product-card .space-between-header {
    margin-bottom: 0px !important;
    justify-content: center;
}

.checkIconBreakdown {
    background-color: #50B767 !important;
}

.crossIconBreakdown {
    background-color: #8C0000 !important;
}

/* .asin-compare-card>div:last-child .border-left-asin {
    padding-right: 1.5rem !important;
} */


.productCart {
    border: 1px solid #D4D4D4;
    border-radius: 10px;
    height: 300px;
}

.copy-breakdown {
    background-color: #0096881A;
    height: 54px;
}

.media-breakdown {
    background-color: #6956E51A;
    height: 52px;
}

.review-breakdown {
    background-color: #FD55421A;
    height: 49px;
}

.graphBorder {
    border: 1px solid #D4D4D4;
    border-radius: 20px;
}

button.primarycolorShow {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 6px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: 100;
    font-size: 14px;
}

button.primarycolorShow:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

@media screen and (max-width:1600px) {
    button.primarycolorShow {
        font-size: 10px !important;
    }
}
</style>
